var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowPartnersDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.001H20C20.5523 13.001 21 12.5533 21 12.001C21 11.4487 20.5523 11.001 20 11.001H4C3.44772 11.001 3 11.4487 3 12.001C3 12.5533 3.44772 13.001 4 13.001Z",
    fill: "#515151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2929 17.2939C12.9024 17.6844 12.9024 18.3176 13.2929 18.7081C13.6834 19.0986 14.3166 19.0986 14.7071 18.7081L20.7071 12.7081C21.0976 12.3176 21.0976 11.6844 20.7071 11.2939L14.7071 5.29387C14.3166 4.90335 13.6834 4.90335 13.2929 5.29387C12.9024 5.68439 12.9024 6.31756 13.2929 6.70808L18.5858 12.001L13.2929 17.2939Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowPartnersDetails);
export default __webpack_public_path__ + "static/media/iconArrowPartnersDetails.658dfc08fe4717e85fbe181459ed121f.svg";
export { ForwardRef as ReactComponent };